import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';

import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { awsmobile } from './aws-exports';
import reportWebVitals from './reportWebVitals';

Amplify.configure(awsmobile);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Authenticator.Provider>
      <App />
    </Authenticator.Provider>
  </StrictMode>
);

// Report web vitals to console in development, or send to analytics in production
// Learn more: https://web.dev/vitals/
reportWebVitals((metric) => {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log(metric);
  }
  // In production, send to your analytics service
  // Example: sendToAnalytics(metric);
});
